<template>
  <div>
    <quill-editor
      :options="{}"
      :content="content"
      ref="quillEditor"
      @focus="onEditorFocus($event)"
    />
  </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor';
import { getMemberSet } from '@/api/api-venue';

export default {
  components: {
    quillEditor,
  },
  data() {
    return {
      content: '',
    };
  },
  created() {
    this.onGet();
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.quillEditor.quill.enable(false);
    });
  },
  methods: {
    async onGet() {
      try {
        const { extend_content: content } = await getMemberSet();
        this.content = content || '_';
      } catch (error) {}
    },
    onEditorFocus(quill) {
      quill.enable(false);
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .quill-editor {
  padding: 12px 16px;
  .ql-editor {
    padding: 0;
  }
  .ql-toolbar {
    display: none;
  }
  .ql-container {
    border: 0;
  }
}
</style>
